import { render, staticRenderFns } from "./BlockAudioViewer.vue?vue&type=template&id=d87ae07c"
import script from "./BlockAudioViewer.vue?vue&type=script&lang=js"
export * from "./BlockAudioViewer.vue?vue&type=script&lang=js"
import style0 from "./BlockAudioViewer.vue?vue&type=style&index=0&id=d87ae07c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports